// The selected region is kept in localStorage and sent as the `region` header on every request
const STORAGE_KEY = 'region'
const listeners = new Set<() => void>()

export default class RegionService {
    static readonly regions = ['SG', 'ID', 'MY', 'HK']

    static get(): string {
        return localStorage.getItem(STORAGE_KEY) || 'SG'
    }

    static set(region: string) {
        localStorage.setItem(STORAGE_KEY, region)
        listeners.forEach((listener) => listener())
    }

    static subscribe(listener: () => void): () => void {
        listeners.add(listener)
        return () => {
            listeners.delete(listener)
        }
    }
}
